import React from "react";
import { Link } from "gatsby";
import ReactGA from "react-ga";
import StaticPage from "../components/StaticPage";
import SEO from "../components/SEO";

ReactGA.initialize("UA-141669883-1");

const Terms = () => {
  if (typeof window !== "undefined") ReactGA.pageview("/terms");

  return (
    <>
      <SEO
        title="Terms of Service"
        description="The terms and conditions governing your use of Andhra Headlines."
        pathname="/terms"
      />
      <StaticPage
        title="Terms of Service"
        breadcrumb="Terms of Service"
        subtitle="Last Updated: January 2025"
      >
        <p>
          Welcome to Andhra Headlines (andhraheadlines.com). By accessing or using our
          website, you agree to be bound by these Terms of Service. Please read
          them carefully.
        </p>

        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing and using this website, you accept and agree to be bound
          by these Terms of Service and our Privacy Policy. If you do not agree
          to these terms, please do not use our website.
        </p>

        <h2>2. Use of Website</h2>
        <p>
          You agree to use this website only for lawful purposes and in a way
          that does not:
        </p>
        <ul>
          <li>Infringe the rights of others</li>
          <li>Restrict or inhibit anyone else's use of the website</li>
          <li>Violate any applicable laws or regulations</li>
          <li>Transmit any harmful, threatening, or offensive content</li>
          <li>Attempt to gain unauthorized access to our systems</li>
        </ul>

        <h2>3. Intellectual Property</h2>
        <p>
          All content on this website, including text, images, graphics, logos,
          and software, is the property of Andhra Headlines or its content
          suppliers and is protected by copyright and intellectual property
          laws. You may not reproduce, distribute, or create derivative works
          without our express written permission.
        </p>

        <h2>4. User Comments</h2>
        <p>
          Users may post comments on articles. By posting a comment, you grant
          us a non-exclusive, royalty-free license to use, reproduce, and
          display your comment. You are solely responsible for the content of
          your comments and agree not to post content that is defamatory,
          offensive, or violates any laws.
        </p>

        <h2>5. Disclaimer</h2>
        <p>
          The information on this website is provided "as is" without any
          warranties, express or implied. We do not guarantee the accuracy,
          completeness, or usefulness of any information on the website. News
          content is for informational purposes only and should not be construed
          as professional advice.
        </p>

        <h2>6. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, Andhra Headlines shall not be
          liable for any indirect, incidental, special, consequential, or
          punitive damages arising from your use of the website or any content
          therein.
        </p>

        <h2>7. Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites. We are not
          responsible for the content, privacy practices, or terms of service of
          these external sites. Accessing third-party links is at your own risk.
        </p>

        <h2>8. Advertising</h2>
        <p>
          This website displays advertisements provided by third-party
          advertising networks, including Google AdSense. These ads may use
          cookies and similar technologies to serve relevant advertisements.
          Please refer to our <Link to="/privacy-policy">Privacy Policy</Link>{" "}
          for more information.
        </p>

        <h2>9. Changes to Terms</h2>
        <p>
          We reserve the right to modify these Terms of Service at any time.
          Changes will be effective immediately upon posting on the website.
          Your continued use of the website after any changes constitutes
          acceptance of the new terms.
        </p>

        <h2>10. Governing Law</h2>
        <p>
          These Terms of Service shall be governed by and construed in
          accordance with the laws of India, without regard to its conflict of
          law provisions.
        </p>

        <h2>11. Contact</h2>
        <p>
          If you have any questions about these Terms of Service, please contact
          us at:
        </p>
        <p>
          <strong>Email:</strong>{" "}
          <a href="mailto:editor@andhraheadlines.com">
            editor@andhraheadlines.com
          </a>
          <br />
          <strong>Website:</strong>{" "}
          <a href="https://www.andhraheadlines.com" target="_blank" rel="noopener noreferrer">
            https://www.andhraheadlines.com
          </a>
        </p>
      </StaticPage>
    </>
  );
};

export default Terms;
